import React, { FC } from 'react';
import { Button, ButtonProps } from 'antd';
import { onArticleClick } from '../../utils/HelpArticleButton';
import track from 'utils/analytics';

type Props = {
  articleId: number;
  clientName: string;
  buttonProps?: Omit<ButtonProps, 'children' | 'onClick'>;
};

export const McpInstallGuideButton: FC<Props> = ({
  articleId,
  clientName,
  buttonProps
}) => (
  <Button
    type="default"
    {...buttonProps}
    onClick={() => {
      track('Viewed MCP install docs', { client_name: clientName });
      onArticleClick({ articleId });
    }}
  >
    Install Guide
  </Button>
);
